
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en-eu/resources/[topic]/[article]",
      function () {
        return require("private-next-pages/en-eu/resources/[topic]/[article].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en-eu/resources/[topic]/[article]"])
      });
    }
  